const shape = {
  line: {
    thin: 1,
    medium: 2,
    thick: 4,
  },
};

export default shape;
